import React from 'react';
import { MapPin, Star } from 'lucide-react';
import { Card } from '../ui/Card';
import { Badge } from '../ui/Badge';
import { Spot } from '../../utils/mockData';
import { motion } from 'framer-motion';
interface SpotCardProps {
  spot: Spot;
  onClick: () => void;
  compact?: boolean;
}
export function SpotCard({
  spot,
  onClick,
  compact = false
}: SpotCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} whileHover={{
    y: -4
  }} transition={{
    duration: 0.3
  }} data-id="element-52">
      <Card variant="interactive" onClick={onClick} className="h-full flex flex-col" data-id="element-53">
        <div className={`relative ${compact ? 'h-32' : 'h-48'} overflow-hidden`} data-id="element-54">
          <img src={spot.image} alt={spot.name} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" data-id="element-55" />
          <div className="absolute top-2 right-2 bg-white/90 dark:bg-slate-900/90 backdrop-blur-sm px-2 py-1 rounded-lg flex items-center shadow-sm" data-id="element-56">
            <Star className="w-3 h-3 text-yellow-500 fill-yellow-500 mr-1" data-id="element-57" />
            <span className="text-xs font-bold text-text" data-id="element-58">{spot.rating}</span>
          </div>
        </div>

        <div className="p-4 flex-1 flex flex-col" data-id="element-59">
          <div className="flex justify-between items-start mb-2" data-id="element-60">
            <h3 className="font-bold text-text text-lg line-clamp-1" data-id="element-61">
              {spot.name}
            </h3>
          </div>

          <div className="flex items-center text-text-muted text-sm mb-3" data-id="element-62">
            <MapPin className="w-4 h-4 mr-1 text-primary" data-id="element-63" />
            <span data-id="element-64">{spot.distance}</span>
          </div>

          {!compact && <div className="flex flex-wrap gap-2 mt-auto" data-id="element-65">
              {spot.species.slice(0, 2).map(fish => <Badge key={fish} variant="default" data-id="element-66">
                  {fish}
                </Badge>)}
              {spot.species.length > 2 && <Badge variant="outline" data-id="element-67">+{spot.species.length - 2}</Badge>}
            </div>}
        </div>
      </Card>
    </motion.div>;
}